import { IStatusMessage } from '../StatusMessage/StatusMessage';

export enum EStatusMessageType {
	success,
	info,
	error,
	grand
}

export interface IStatusMessageType {
	type: EStatusMessageType;
	color: string;
	background?: string;
}

const statusMessageTypes: IStatusMessageType[] = [
	{ type: EStatusMessageType.success, color: `lightgreen` },
	{ type: EStatusMessageType.info, color: `lightblue` },
	{ type: EStatusMessageType.error, color: `coral` },
	{
		type: EStatusMessageType.grand,
		color: `gold`,
		background: 'linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(/images/backgrounds/0_swal.jpg)'
	}
];

export function GetStatusMessageColor(statusMessage: IStatusMessage) {
	const statusMessageType = statusMessageTypes.find((type) => type.type === statusMessage.type);

	if (statusMessageType) {
		return statusMessageType.color;
	}
}

export function GetBackground(statusMessage: IStatusMessage) {
	const statusMessageType = statusMessageTypes.find((type) => type.type === statusMessage.type);

	if (statusMessageType && statusMessageType.background) {
		return statusMessageType.background;
	}
}
